module.exports = __webpack_public_path__ + "static/media/loader-car.941328f5.gif";